import React from 'react';
import BuyGridAccordion from '../../../components/BuyGridAccordion/BuyGridAccordion';
import ShippingAndReturnsAccordionContent from './ShippingAndReturnsAccordionContent';

export default function ShippingAndReturnsAccordion({
  activeAccordion, onClick, shippingContent, tmntData, siteRegion,
}) {
  const { shippingAndReturnsAccordionHeaderText } = tmntData || {};
  const accordionIdentifier = 'product-shipping-return';

  return (
    <BuyGridAccordion
      id="shipping-and-returns"
      headerText={shippingAndReturnsAccordionHeaderText?.value}
      onClick={onClick(accordionIdentifier)}
      expanded={activeAccordion === accordionIdentifier}
    >
      <ShippingAndReturnsAccordionContent
        shippingContent={shippingContent}
        tmntContent={tmntData}
        siteRegion={siteRegion}
      />
    </BuyGridAccordion>
  );
}
